import React, { forwardRef } from 'react';
import classNames from 'classnames';

interface RadioButtonProps {
  title?: string;
  id: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  value?: string;
}

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ title, id, name, onChange, checked = false, value, ...props }, ref) => {
    return (
      <div className='c-radio-button'>
        <label className='c-radio-button-container'>
          <input
            ref={ref}
            type='radio'
            onChange={onChange}
            className='checkmark'
            name={name}
            value={value || title}
            id={id}
            defaultChecked={checked}
            {...props}
          />
          {title}
        </label>
      </div>
    );
  }
);
